import React from 'react';

import { AppState } from 'types/appState';
import { createAppState } from 'utils/createAppState';

export const AppStateContext = React.createContext<AppState>(createAppState());
